import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const GlobeIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM9.28378 2.90949C9.58572 2.5853 9.82831 2.5 10 2.5C10.1717 2.5 10.4143 2.5853 10.7162 2.90949C11.0192 3.23477 11.3265 3.74635 11.6003 4.44126C12.0834 5.66766 12.4163 7.34835 12.4863 9.25H7.51373C7.58375 7.34835 7.91658 5.66766 8.39971 4.44126C8.67346 3.74635 8.98082 3.23477 9.28378 2.90949ZM6.0128 9.25C6.08326 7.19424 6.44133 5.32004 7.0041 3.89148C7.13584 3.55704 7.28139 3.24042 7.44097 2.94791C4.78379 3.91234 2.82637 6.33582 2.53703 9.25H6.0128ZM2.53703 10.75H6.0128C6.08326 12.8058 6.44133 14.68 7.0041 16.1085C7.13584 16.443 7.28139 16.7596 7.44097 17.0521C4.78379 16.0877 2.82637 13.6642 2.53703 10.75ZM7.51373 10.75H12.4863C12.4163 12.6516 12.0834 14.3323 11.6003 15.5587C11.3265 16.2537 11.0192 16.7652 10.7162 17.0905C10.4143 17.4147 10.1717 17.5 10 17.5C9.82831 17.5 9.58572 17.4147 9.28378 17.0905C8.98082 16.7652 8.67346 16.2537 8.39971 15.5587C7.91658 14.3323 7.58375 12.6516 7.51373 10.75ZM13.9872 10.75C13.9167 12.8058 13.5587 14.68 12.9959 16.1085C12.8642 16.443 12.7186 16.7596 12.559 17.0521C15.2162 16.0877 17.1736 13.6642 17.463 10.75H13.9872ZM17.463 9.25C17.1736 6.33582 15.2162 3.91234 12.559 2.94791C12.7186 3.24042 12.8642 3.55704 12.9959 3.89148C13.5587 5.32004 13.9167 7.19424 13.9872 9.25H17.463Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
